/*
 * TNxi suite builder (sections/tnxi-suite.liquid).
 *
 * Fixed kit: avionics variant choice + a fixed component list. Prices and stock come from
 * the section's config JSON; Add adds every component as its own line item tagged
 * properties._bundle=<uuid> so the kit decomposes in the order, like the panel bundles.
 *
 * The savings shown here are cosmetic — the real discount is a native automatic rule.
 */
(function () {
  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = (format || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
    return out.replace(/([.,])00(?=\D*$)/, ''); // drop trailing .00 for whole amounts
  }

  // Can this component satisfy the required quantity given its inventory?
  function canFulfill(item, qty) {
    if (!item || item.id == null) return false;
    if (!item.inv || !item.inv.managed) return true; // inventory not tracked
    if (item.inv.policy === 'continue') return true; // overselling allowed
    return (item.inv.qty || 0) >= qty;
  }

  function sumLine(label, value, cls) {
    return (
      '<div class="tnxi-bundle__sum-line' + (cls ? ' ' + cls : '') + '">' +
      '<span>' + label + '</span><span>' + value + '</span></div>'
    );
  }

  function initSection(section) {
    var cfgEl = document.querySelector('[data-suite-config="' + section.id.replace('tnxi-suite-', '') + '"]')
      || section.parentNode.querySelector('[data-suite-config]');
    if (!cfgEl) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    if (!cfg.avionics || !cfg.avionics.length) return;

    var priceEl = section.querySelector('[data-suite-price]');
    var summaryEl = section.querySelector('[data-suite-summary]');
    var stockEl = section.querySelector('[data-suite-stock]');
    var addBtn = section.querySelector('[data-suite-add]');
    var avionicsBtns = [].slice.call(section.querySelectorAll('[data-avionics-id]'));
    var components = cfg.components || [];

    // Default to the first avionics variant that can actually be fulfilled.
    var selectedAvionicsId = null;
    for (var i = 0; i < cfg.avionics.length; i++) {
      if (canFulfill(cfg.avionics[i], cfg.avionicsQty)) { selectedAvionicsId = cfg.avionics[i].id; break; }
    }
    if (selectedAvionicsId == null) selectedAvionicsId = cfg.avionics[0].id;

    function avionicsById(id) {
      for (var i = 0; i < cfg.avionics.length; i++) if (cfg.avionics[i].id === id) return cfg.avionics[i];
      return null;
    }

    function render() {
      var av = avionicsById(selectedAvionicsId);
      if (!av) return;

      var total = cfg.avionicsQty * av.price;
      components.forEach(function (c) { total += (c.qty || 1) * c.price; });

      var suiteSaved = Math.min((cfg.discountAmount || 0) * 100, total);
      var extraSaved = Math.max(0, Math.min((cfg.preorderDiscount || 0) * 100, total - suiteSaved));
      var saved = suiteSaved + extraSaved;
      var discounted = total - saved;

      var suiteBadge = (cfg.discountBadge && cfg.discountBadge.trim())
        ? cfg.discountBadge
        : money(suiteSaved, cfg.moneyFormat) + ' suite saving';
      // With a second saving the pill shows the combined total, so it matches the cart.
      var badge = extraSaved > 0 ? money(saved, cfg.moneyFormat) + ' off' : suiteBadge;

      if (priceEl) {
        var html = '';
        if (saved > 0) {
          html += '<span class="tnxi-bundle__now">' + money(discounted, cfg.moneyFormat) + '</span>';
          html += '<s class="tnxi-bundle__was">' + money(total, cfg.moneyFormat) + '</s>';
          html += '<span class="tnxi-bundle__pill">' + badge + '</span>';
        } else {
          html += '<span class="tnxi-bundle__now">' + money(total, cfg.moneyFormat) + '</span>';
        }
        priceEl.innerHTML = html;
      }

      if (summaryEl) {
        var s = '';
        s += sumLine(cfg.avionicsQty + '× ' + cfg.avionicsName + ' — ' + av.title, money(cfg.avionicsQty * av.price, cfg.moneyFormat));
        components.forEach(function (c) {
          var q = c.qty || 1;
          s += sumLine(q + '× ' + c.title, money(q * c.price, cfg.moneyFormat));
        });
        if (suiteSaved > 0) s += sumLine(suiteBadge, '-' + money(suiteSaved, cfg.moneyFormat), 'tnxi-bundle__sum-line--save');
        if (extraSaved > 0) s += sumLine(cfg.preorderLabel || 'Pre-order discount', '-' + money(extraSaved, cfg.moneyFormat), 'tnxi-bundle__sum-line--save');
        s += sumLine('Total', money(discounted, cfg.moneyFormat), 'tnxi-bundle__sum-line--total');
        summaryEl.innerHTML = s;
      }

      // ---- availability ----
      var avOk = canFulfill(av, cfg.avionicsQty);
      var missing = null;
      components.forEach(function (c) {
        if (!missing && !canFulfill(c, c.qty || 1)) missing = c.title;
      });

      avionicsBtns.forEach(function (btn) {
        var id = parseInt(btn.getAttribute('data-avionics-id'), 10);
        var v = avionicsById(id);
        var ok = canFulfill(v, cfg.avionicsQty);
        btn.disabled = !ok;
        btn.classList.toggle('is-active', id === selectedAvionicsId);
        btn.classList.toggle('is-disabled', !ok);
      });

      if (addBtn) addBtn.disabled = !(avOk && !missing);
      if (stockEl) {
        if (!avOk) {
          stockEl.textContent = 'Selected avionics is out of stock (need ' + cfg.avionicsQty + ').';
          stockEl.hidden = false;
        } else if (missing) {
          stockEl.textContent = missing + ' is out of stock.';
          stockEl.hidden = false;
        } else {
          stockEl.hidden = true;
        }
      }
    }

    avionicsBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        selectedAvionicsId = parseInt(btn.getAttribute('data-avionics-id'), 10);
        render();
      });
    });

    // Thumbnail gallery (same behaviour as the panel bundle section).
    var mainImage = section.querySelector('.tnxi-bundle__main-image');
    section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.removeAttribute('srcset');
        mainImage.src = thumb.getAttribute('data-thumb');
        section.querySelectorAll('.tnxi-bundle__thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var av = avionicsById(selectedAvionicsId);
        if (!av) return;
        var bundleId = 'fvs-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
        // The whole kit ships together, so every line carries the pre-order window.
        function props() {
          var p = { _bundle: bundleId };
          if (cfg.shipsNote) p[cfg.shipsLabel || 'Ships'] = cfg.shipsNote;
          return p;
        }
        var items = [{ id: av.id, quantity: cfg.avionicsQty, properties: props() }];
        components.forEach(function (c) {
          items.push({ id: c.id, quantity: c.qty || 1, properties: props() });
        });

        addBtn.classList.add('is-loading');
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () {
            addBtn.classList.remove('is-loading');
            addBtn.disabled = false;
            if (stockEl) {
              stockEl.textContent = 'Sorry — could not add to cart. Please try again.';
              stockEl.hidden = false;
            }
          });
      });
    }

    render();
  }

  document.querySelectorAll('[data-tnxi-suite]').forEach(initSection);
})();
